module.exports = __webpack_public_path__ + "static/media/beta.af0c387d.svg";